import publicApi from "../config/publicApi";

/**
 * Submit a public enquiry from the MaX marketing site.
 * @param {{ name: string, phoneNumber: string, companyName: string }} payload
 */
export async function submitEnquiry(payload) {
  const { data } = await publicApi.post("/enquiry", payload);
  return data;
}
